// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"ac05a53f","209":"5f6d4424","279":"2411c57f","903":"d40a524c"}[chunkId] + ".chunk.js";
};